/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './describeRepo.defs'
export { main as default } from './describeRepo.defs'
